import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theme';
import { Intl } from '@jetshop/intl';
import { Above } from '@jetshop/ui/Breakpoints';

const Input = styled('input')`
  grid-area: ${props => props.gridArea};
  background: transparent;
  border: 1px solid #d2d2d2;
  box-shadow: 0;
  height: 32px;
  color: ${theme.colors.black};
  width: 100%;
  font-size: 16px;
  padding-left: 10px;
  padding-right: 40px; /* Increased right padding to make room for cancel button */
  margin: auto;
  ${theme.above.md} {
    background: ${theme.colors.white};
  }
  &:focus {
    outline: none;
    border-color: #80937b;
    box-shadow: 0 0 0 1px rgba(255, 102, 0, 0.1);
  }

  -webkit-appearance: none;
  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3Cpath fill='currentColor' d='M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z'/%3E%3C/svg%3E"); /* url(./svg/MenuClose.svg); */
    height: 16px;
    width: 16px;
    display: block;
    cursor: pointer;
    margin-right: 8px; /* Add some margin to position it properly */
  }
`;

const SearchInputNew = ({
  isDirty,
  getInputProps,
  gridArea,
  setSearchOpen,
  inputValue,
  setInputValue,
  triggerSearch
}) => {
  return (
    <Intl>
      {t => (
        <Above breakpoint="xs">
          {matches => (
            <Input
              id="search-input-mobile"
              gridArea={gridArea}
              type="search"
              {...getInputProps({
                refKey: 'innerRef'
              })}
              value={inputValue}
              isDirty={isDirty}
              placeholder={
                matches
                  ? t('Search for products for horse, riders and dogs...')
                  : t('Search')
              }
              aria-label={t('Search')}
              onInput={e => {
                setInputValue(e.target.value);
                setSearchOpen(true);
              }}
              onKeyDown={e => {
                // IF ENTER SUBMIT WHEN NO VALUE RETURN NULL
                if (e.key === 'Enter') {
                  if (!inputValue.length > 0) {
                    return null;
                  } else {
                    triggerSearch();
                  }
                }
              }}
            />
          )}
        </Above>
      )}
    </Intl>
  );
};

export default SearchInputNew;
